<div class="input-group d-flex flex-nowrap date-picker-custom-class">
  <input
    [formControl]="formControl"
    [formlyAttributes]="field"
    [minDate]="minDate$ | async"
    [maxDate]="maxDate$ | async"
    [markDisabled]="markDateDisable$ | async"
    outsideDays="collapsed"
    navigation="arrows"
    class="form-control"
    [ngClass]="props.inputClass"
    name="dp"
    ngbDatepicker
    #d="ngbDatepicker"
    data-testing-id="date-picker"
    [attr.aria-label]="props.ariaLabel"
    [attr.aria-required]="props.required ? 'true' : undefined"
    [attr.aria-invalid]="showError ? 'true' : undefined"
    [attr.aria-describedby]="props.ariaDescribedByIds"
  />

  <div class="input-group-append">
    <button
      class="btn btn-secondary py-1"
      (click)="d.toggle()"
      type="button"
      data-testing-id="btn-date-picker"
      title="{{ 'checkout.shipping.calendar.title' | translate }}"
      aria-haspopup="dialog"
      aria-expanded="false"
    >
      <fa-icon class="text-primary" icon="calendar-day" />
    </button>
  </div>
</div>
